import { render, staticRenderFns } from "./RecentChanges.vue?vue&type=template&id=9bd3f91e"
import script from "./RecentChanges.vue?vue&type=script&lang=ts"
export * from "./RecentChanges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports